import React from 'react'
import CookieConsent from 'react-cookie-consent'
import useWindowSize from 'styles/window-size'

import { Wrap, Content, LinkItem, ButtonClose } from './index.styled'

const CookiesBanner = () => {
  const ref = React.useRef()
  const { width } = useWindowSize()

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      ref?.current?.classList?.add('show')
    }, 8000)
    return () => clearTimeout(timeout)
  }, [])

  const onClose = () => {
    ref?.current?.classList?.remove('show')
  }

  return (
    <Wrap ref={ref}>
      <CookieConsent
        location='none'
        buttonText='ALLOW'
        disableStyles
        containerClasses='cookies-banner'
        buttonClasses='cookies-banner-accept-btn'
        disableButtonStyles
        buttonWrapperClasses='cookies-banner-btns'
        contentClasses='cookies-banner-content'
        expires={150}
        // debug={true}
      >
        <Content>
          {width >= 768
            ? (
              <>
                This website uses cookies to ensure you get the best experience on our website. <LinkItem href='https://www.cookiesandyou.com' target='_blank'>Learn more</LinkItem>.
              </>
              )
            : (
              <>
                This website uses <LinkItem href='https://www.cookiesandyou.com' target='_blank'>cookies</LinkItem>.
              </>
              )}
        </Content>
        <ButtonClose onClick={onClose} />
      </CookieConsent>
    </Wrap>
  )
}
export default CookiesBanner
